module.exports = __webpack_public_path__ + "media/images/discount-4f30f0a5a500813eaf1a12d4ce0cf48e.png";